var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropaneTank24DpFill0Wght400Grad0Opsz241(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 55C17.25 55 14.8958 54.0208 12.9375 52.0625C10.9792 50.1042 10 47.75 10 45V25C10 22.625 10.7083 20.5625 12.125 18.8125C13.5417 17.0625 15.3333 15.8958 17.5 15.3125V10C17.5 8.625 17.9896 7.44792 18.9688 6.46875C19.9479 5.48958 21.125 5 22.5 5H37.5C38.875 5 40.0521 5.48958 41.0312 6.46875C42.0104 7.44792 42.5 8.625 42.5 10V15.3125C44.6667 15.8958 46.4583 17.0625 47.875 18.8125C49.2917 20.5625 50 22.625 50 25V45C50 47.75 49.0208 50.1042 47.0625 52.0625C45.1042 54.0208 42.75 55 40 55H20ZM15 32.5H45V25C45 23.625 44.5104 22.4479 43.5312 21.4688C42.5521 20.4896 41.375 20 40 20H20C18.625 20 17.4479 20.4896 16.4688 21.4688C15.4896 22.4479 15 23.625 15 25V32.5ZM20 50H40C41.375 50 42.5521 49.5104 43.5312 48.5312C44.5104 47.5521 45 46.375 45 45V37.5H15V45C15 46.375 15.4896 47.5521 16.4688 48.5312C17.4479 49.5104 18.625 50 20 50ZM32.5 15H37.5V10H22.5V15H27.5C27.5 14.2917 27.7396 13.6979 28.2188 13.2188C28.6979 12.7396 29.2917 12.5 30 12.5C30.7083 12.5 31.3021 12.7396 31.7812 13.2188C32.2604 13.6979 32.5 14.2917 32.5 15Z",
    fill: "#031273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropaneTank24DpFill0Wght400Grad0Opsz241);
export default __webpack_public_path__ + "static/media/propane_tank_24dp_FILL0_wght400_GRAD0_opsz24 1.839ca1b3e8b21e8738184380e5bf45ef.svg";
export { ForwardRef as ReactComponent };